<!--人员管理-->
<template>
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">销售管理 ></p>
            <el-input placeholder="姓名/手机号" v-model="selectValue" size="small" class="input-with-select" style="width:300px">
                <el-button slot="append" icon="el-icon-search" @click="curr=1;getList()"></el-button>
            </el-input>
            <div></div>
        </div>
        <div class="table" style="height:calc( 100% - 100px )">
            <el-table :data="list" border :header-cell-style="{background:'#fafdff',color:'#606266',fontWeight:'normal'}" height="calc( 100% - 120px )">
                <el-table-column label="序号" width="70px" align="center">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mobile" label="手机号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="state_name" label="在职状态" show-overflow-tooltip></el-table-column>
                <el-table-column prop="printer_name" label="打印机" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state_name=='离职'" type="primary" size="small" plain @click="editState(scope.row.id)">在职</el-button>
                        <el-button v-if="scope.row.state_name=='在职'" type="danger"  size="small" plain @click="editState(scope.row.id)">离职</el-button>
                        <el-button type="success" size="small" plain @click="editDialog(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>

        <!--编辑-->
        <el-dialog :visible="dialogOpen" :title="dialogTitle" :close-on-click-modal="false" width="600px" @close=" closeDialog " :append-to-body="true" :destroy-on-close="true">
            <div class="editBox">
                <el-form ref="edit" :model="formData" :rules="formRules" @submit.native.prevent label-width="70px">
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model="formData.mobile"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="打印机" prop="printer_id" >
                        <el-select v-model="formData.printer_id" clearable placeholder="请选择打印机" @change="curr=1;getList()" style="width: 100%;">
                            <el-option v-for="(item,index) in printList" :label="item.name" :value="item.id" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="editBtn">
                <el-button type="primary" size="small" @click="submit()">保存</el-button>
                <el-button size="small" @click="closeDialog">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Home',
        data: function () {
            return {
                curr: 1,
                row: 10,
                count: 0,
                pages: 1, //总页数
                selectValue: '',
                dialogTitle:'编辑',
                dialogOpen:false,

                printList:[],
                list: [],
                formData: {},

                // 表单验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入寄件人姓名',
                        trigger: 'change'
                    }],
                    mobile: [{
                        required: true,
                        pattern: /^1[0-9][0-9]\d{8}$/,
                        message: '电话格式不正确',
                        trigger: 'change'
                    }],
                    printer_id: [{
                        required: true,
                        message: '请选择打印机',
                        trigger: 'change'
                    }],
                },
            }
        },
        mounted: function () {
            this.getList()
            this.getPrintList()
        },
        methods: {
            //获取
            getList: function () {
                this.http.post('/user/getList', {
                    row: this.row,
                    curr: this.curr,
                    search: this.selectValue
                }).then(res => {
                    this.list = res.list
                    this.curr = res.curr;
                    this.pages = res.pages;
                    this.count = res.count;
                })
            },
            //获取打印机下拉列表
            getPrintList:function(){
                this.http.post('/setting/getList',{
                    row:100000000,
                    curr:1,
                    type: 'printer'
                }).then(res => {
                    this.printList = res.list
                })
            },
            //编辑用户
            editDialog(data) {
                this.dialogOpen = true
                var form = JSON.stringify(data)
                this.formData = JSON.parse(form)
                this.formData.printer_id = this.formData.printer_id == 0 ? '' : this.formData.printer_id
            },
            editState:function(id){
                this.$confirm('确定要修改状态吗?', '提示').then(() => {
                    this.http.post('/user/quit', {
                        id: id
                    }).then(res => {
                        this.$message.success('修改成功')
                        this.getList()
                    })
                }).catch(() => {
                    this.$message.info('已取消')
                });
            },
            addressChange(value) {
                this.formData.address = value;
            },
            //提交
            submit: function () {
                this.$refs['edit'].validate((valid) => {
                    if (valid) {
                        this.http.post('/user/edit',this.formData).then(res=>{
                            this.$message.success('保存成功')
                            this.dialogOpen = false
                            this.getList()
                        })
                    }
                })
            },

            closeDialog:function(){
                this.dialogOpen = false
                this.$refs['edit'].resetFields();
            },
            
            currChange: function (curr) {
                this.curr = curr;
                this.getList()
            },
            sizeChange: function (row) {
                this.row = row;
                this.getList()
            },
        }
    }
</script>